import React from 'react';
import { Box } from '@mui/material';
import { panelTitleSx } from '../../Map/components/PanelShell/PanelHeader';

/** Raíz de la ruta en el título: el mismo texto tenue que el subtítulo del header. */
export const META_TITLE_PARENT_COLOR = 'rgba(255,255,255,0.45)';

// El `overflow: hidden` del ellipsis recortaba la tilde de «Ñ» y de «Ú» (line-height 20px): se le da aire
// arriba y abajo con padding y se compensa con margen negativo (el layout no cambia).
const ellipsisSx = {
  minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pt: '5px', pb: '3px', mt: '-5px', mb: '-3px',
};

/**
 * Título del panel con ruta: «CAMPAÑAS / PÚBLICO». Misma tipografía que `PanelHeader`
 * (`panelTitleSx`); la raíz va tenue y es solo texto (no navega: para volver está la flecha).
 * Sin `current` → solo «CAMPAÑAS». En paneles angostos se achica primero la raíz (ellipsis).
 */
const MetaAdsPanelTitle = ({ root, current = null }) => {
  if (!current) {
    return <Box component="h2" sx={{ ...panelTitleSx, ...ellipsisSx }} data-testid="meta-ads-title">{root}</Box>;
  }
  const label = `${root} / ${current}`;
  return (
    <Box
      component="h2"
      aria-label={label}
      title={label}
      sx={{ ...panelTitleSx, display: 'flex', alignItems: 'baseline', minWidth: 0, whiteSpace: 'nowrap' }}
      data-testid="meta-ads-title"
    >
      <Box component="span" sx={{ ...ellipsisSx, flex: '0 100000 auto', color: META_TITLE_PARENT_COLOR }} data-testid="meta-ads-title-root">
        {root}
      </Box>
      <Box component="span" aria-hidden sx={{ flexShrink: 0, color: META_TITLE_PARENT_COLOR, whiteSpace: 'pre' }}>{' / '}</Box>
      <Box component="span" sx={{ ...ellipsisSx, flex: '0 1 auto' }} data-testid="meta-ads-title-current">
        {current}
      </Box>
    </Box>
  );
};

export default MetaAdsPanelTitle;
